<template>
    <div class="bg-white p-5 pb-1 mb-3 rounded">
        <h2 class="ranking-title mb-3">Ranking de colaboradores</h2>

        <h3><strong>Colaboradores destacados</strong></h3>
        <div class="row mt-1">
            <div class="col-md-4" v-if="mostCoursesUser">
                <div class="card awardcard">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col-9">
                                <span>Más cursos completados</span>
                                <h1 class="awardcard__name">{{ mostCoursesUser.name }}</h1>
                            </div>
                            <div class="col-3">
                                <div class="awardvalue d-flex flex-column py-2 justify-content-center align-items-center">
                                    <h3 class="awardvalue__value mb-0">{{ mostCoursesUser.finished_courses }}</h3>
                                    <small class="awardvalue__text" >Cursos</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4" v-if="bestAwardUser">
                <div class="card awardcard">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col-9">
                                <span>Mejor galardón</span>
                                <h1 class="awardcard__name">{{ bestAwardUser.name }}</h1>
                            </div>
                            <div class="col-3">
                                <div class="awardvalue d-flex flex-column py-2 justify-content-center align-items-center">
                                    <img width="42" height="42" class="img-fluid" :src="bestAwardUser.awardImg" alt="">
                                    <small class="awardvalue__text" >{{ bestAwardUser.awardName }}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4" v-if="minAvgUser">
                <div class="card awardcard">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col-9">
                                <span>Mejor promedio finalizando cursos</span>
                                <h1 class="awardcard__name">{{ minAvgUser.name }}</h1>
                            </div>
                            <div class="col-3">
                                <div class="awardvalue d-flex flex-column py-2 justify-content-center align-items-center">
                                    <h3 class="awardvalue__value mb-0">{{ truncateAvg(minAvgUser.hours_avg) < 1 ? truncateAvg(minAvgUser.minutes_avg) : truncateAvg(minAvgUser.hours_avg) }}</h3>
                                    <small class="awardvalue__text" >{{ truncateAvg(minAvgUser.hours_avg) < 1 ? 'Minutos' : 'Horas' }}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-5">
            <div class="d-flex justify-content-between mb-3" style="position: relative;">
                <h3><strong>Lista de colaboradores</strong></h3>
                <a :href="url_report" class="btn bg-utel-v2-secondary sin-borde text-primary rounded-8 mx-1 my-sm-2 pt-2">Descargar
                        reporte</a>
                <div class="tutorial-container-ranking" v-if="showTutorial">
                    <div class="tutorial-content col-md-4 col-sm-6">
                        <div class="card tutorial-card">
                            <div class="card-header text-end ">
                                <div class="card-arrow-ranking"></div>
                                <div class="d-flex justify-content-end">
                                    <button class="btn btn-link text-white" @click="markTutorialAsShowed()"><i
                                            class="fa fa-xmark"></i></button>
                                </div>
                            </div>
                            <div class="card-body">
                                <h3 class="text-white">Ranking de usuarios</h3>
                                <span>¡Impulsa la competencia positiva! Explora el 'Ranking de Colaboradores' para ver el desempeño destacado. Motiva y reconoce logros dentro de tu equipo en Utel X for Business.</span>
                            </div>
                            <div class="card-footer d-flex justify-content-end pb-3 pe-5 pt-2">
                                <a href="#" @click="markTutorialAsShowed(true)" class="text-end text-white">
                                    Ver tutorial
                                    <i class="fa ms-2 fa-arrow-right text-white"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <v-data-table
                :headers="headersTabs"
                :items="users"
                item-key="name"
                :page="page"
                :items-per-page="itemsPerPage"
                class="elevation-1 table text-center align-middle small mt-2"
                loading
                loading-text="Cargando..."
                mobile-breakpoint="0"
                :header-props="{
                    sortIcon: 'fa-solid fa-sort-amount-desc'
                }"
                :footer-props="{
                    prevIcon: 'fa-solid fa-chevron-left',
                    nextIcon: 'fa-solid fa-chevron-right',
                    'items-per-page-text': 'Mostrando: ',
                    'items-per-page-options': [5, 10, 20, 30, 40, 50]
                }"
                hide-default-footer
            >
                <template v-slot:item="row">
                    <tr class="text-center">
                        <td>{{ row.item.position }}</td>
                        <td>{{ row.item.name }}</td>
                        <td>{{ row.item.email }}</td>
                        <td>{{ row.item.awardName }}</td>
                        <td>{{ row.item.finished_courses }}</td>
                        <td>{{ truncateAvg(row.item.hours_avg) < 1
                                ? `${truncateAvg(row.item.minutes_avg)} minutos`
                                : `${truncateAvg(row.item.hours_avg)} horas` }}
                        </td>
                    </tr>
                </template>
                <template v-slot:footer>
                    <div class="text-center pt-2">
                        <v-pagination v-model="page" :length="pageCount" :total-visible="6" next-icon='fas fa-angle-right'
                            prev-icon='fas fa-angle-left'></v-pagination>
                    </div>
                </template>
            </v-data-table>
        </div>
        <modalVideo
            url="https://www.youtube.com/embed/7oUlTZ-3QF8?si=ikYE6NYc2SdTe1NB"
            v-if="openVideoModal"
            @onClose="openVideoModal = false"
        ></modalVideo>
    </div>
</template>

<script>
    import modalVideo from '../tutorials/ModalTutorial.vue';
    export default {
        props: ['url','url_report'],
        data(){
            return {
                users: [],
                bestAwardUser: null,
                minAvgUser: null,
                mostCoursesUser: null,
                headersTabs: [
                    { text: "Puesto", value: "position" },
                    { text: "Nombre", value: "name" },
                    { text: "Correo", value: "email" },
                    { text: "Galardón", value: "awardName" },
                    { text: "Cursos finalizados", value: "finished_courses" },
                    { text: "Prom. horas por curso", value: "avg_hours", align: 'center'},
                ],
                page: 1,
                itemsPerPage: 10,
                showTutorial: false,
                openVideoModal: false
            }
        },
        components: {
            modalVideo
        },
        mounted(){
            this.getData();
            this.checkTutorialsShowed();
        },
        computed: {
            pageCount() {
                return Math.ceil(this.users.length / this.itemsPerPage)
            },
        },
        methods: {
            getData(){
                axios.get(this.url).then(resp => {
                    const { users, bestAwardUser, minAvgUser, mostCoursesUser } = resp.data;
                    this.users = users;
                    this.bestAwardUser = bestAwardUser;
                    this.minAvgUser = minAvgUser;
                    this.mostCoursesUser = mostCoursesUser;
                })
            },
            truncateAvg(avg){
                return avg ? Math.trunc(avg) : 0;
            },
            checkTutorialsShowed() {
                const tutorials = localStorage.getItem('showedtutorials') || null;
                if (tutorials) {
                    const tutorialsArray = JSON.parse(tutorials);
                    if (!tutorialsArray.includes('courses-ranking')) {
                        this.showTutorial = true;
                    }
                } else {
                    this.showTutorial = true;
                }
            },
            markTutorialAsShowed(openVideo = false) {
                const tutorials = localStorage.getItem('showedtutorials') || null;
                if (tutorials) {
                    const currentTutorialsShowed = JSON.parse(tutorials);
                    localStorage.setItem('showedtutorials', JSON.stringify([...currentTutorialsShowed, 'courses-ranking']));
                } else {
                    localStorage.setItem('showedtutorials', JSON.stringify(['courses-ranking']));
                }

                this.showTutorial = false;

                if ( openVideo ) {
                    this.openVideoModal = true;
                }
            }
        }
    }
</script>
<style>
    .ranking-title {
        color: #1A0054;
        font-size: 36px;
        font-weight: 700;
    }

    .awardcard{
        background-color: #E0E2FF4D;
        border-radius: 10px;
        border: none;
        display: flex;
        height: 100%;
        align-items: center;
    }

    .awardcard .card-body{
        width: 100%;
    }

    .awardcard .awardcard__name{
        color: #1A0054;
        font-size: 32px;
        font-weight: 700;
    }

    .awardvalue{
        text-align: center;
        border-radius: 10px;
        background-color: #fff;
    }

    .awardcard .awardvalue__value{
        color: #1A0054;
        font-size: 32px;
        font-weight: 700;
        line-height: 42px;
    }

    .awardvalue .awardvalue__text{
        min-height: 46px;
    }

    .card-arrow-ranking{
        position: absolute;
        width: 40px;
        height: 40px;
        margin-top: -23px;
        background-color: #4000BC;
        transform: rotate(45deg);
        right: 20px;
        z-index: -100;
    }

    .tutorial-container-ranking{
        position: absolute;
        z-index: 100;
        display: flex;
        justify-content: flex-end;
    }

    .tutorial-container-ranking .tutorial-content{
        margin-top: 60px;
    }
</style>
